import { Tab, Tabs } from "@nextui-org/react";
import React from "react";
import { useParams } from "react-router-dom";
import BreadCrumbsPage from "../../components/BreadCrumbsPage";
import UISurveyBuilder from "./UISurveyBuilder";
import JsonSurveyBuilder from "./JsonSurveyBuilder";

/**
 * SurveyBuilder Component
 * Main survey creation interface with tabbed navigation
 * Provides two approaches: UI-based form builder and JSON-based configuration
 * @returns {JSX.Element} Survey builder main interface
 */
export const SurveyBuilder = () => {
  // Organization ID from URL parameters
  const { _orgId: currentOrg } = useParams();

  // Available survey building methods
  const surveyBuilderTabs = [
    {
      id: "Using Form Builder UI",
      label: "Using UI Builder",
      content: <UISurveyBuilder />,
    },
    {
      id: "Using JSON",
      label: "Using JSON",
      content: <JsonSurveyBuilder />,
    },
  ];

  return (
    <BreadCrumbsPage>
      <div className="w-full">
        {/* Page Header */}
        <div className="text-3xl font-medium">Create a Survey</div>
        
        {/* Page Description */}
        <div className="my-8">
          Create a survey and build that would support your ESG Reporting
        </div>
        
        {/* Survey Builder Tabs */}
        <Tabs aria-label="Survey builder tabs" items={surveyBuilderTabs} variant="light">
          {(tab) => (
            <Tab key={tab.id} title={tab.label}>
              {tab.content}
            </Tab>
          )}
        </Tabs>
      </div>
    </BreadCrumbsPage>
  );
};
